import { Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

// Next to a Connect button the demo disables
export const CloudConnectionDemoHint = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "deployments.cloudConnection"
  })

  return <Text type="secondary">{t("demo")}</Text>
}
